<template>
  <div id="contenedor-etiquetas-default">
    <v-container
      fluid>
      <v-card
        class="mb-4"
        flat>
        <v-card-text>
          <titulo-tool-bar></titulo-tool-bar>
          <tool-bar
            class="mb-4"
            :filtros="filtros"
            v-on:nuevaEtiqueta="registrarNuevaEtiqueta"
            >
          </tool-bar>
        </v-card-text>
      </v-card>
      <v-card
        flat>
        <v-card-text>
          <listado :etiquetas="getEtiquetas"></listado>
        </v-card-text>
      </v-card>
    </v-container>
    <!-- CUADRO DE DIALOGO AGREGAR -->
    <v-dialog
      v-model="mostrarVentanaRegistrarNuevaEtiqueta"
      :width="!$vuetify.breakpoint.mobile ? '600' : '90%'">
      <registrar-nueva-etiqueta
        v-if="mostrarVentanaRegistrarNuevaEtiqueta"
        v-on:cerrar="cerrarVentana">
      </registrar-nueva-etiqueta>
    </v-dialog>
    <!-- CUADRO DE DIALOGO EDITAR -->
    <v-dialog
    v-if="estaEtiqueta"
      v-model="mostrarVentanaEditarEtiqueta"
      :width="!$vuetify.breakpoint.mobile ? '600' : '90%'">
      <editar-etiqueta
      :etiquetaEditar="estaEtiqueta"
        v-on:cerrar="cerrarVentana">
      </editar-etiqueta>
    </v-dialog>
    <!-- CUADRO DE DIALOGO ELIMINAR -->
    <v-dialog
    v-if="estaEtiqueta"
      v-model="mostrarVentanaEliminarEtiqueta"
      :width="!$vuetify.breakpoint.mobile ? '450' : '90%'">
      <eliminar-etiqueta
      :etiquetaEliminar="estaEtiqueta"
        v-on:cerrar="cerrarVentana">
      </eliminar-etiqueta>
    </v-dialog>
  </div>
</template>

<script>
import ETIQUETAS from '@/graphql/querys/administracion/catalogos/etiquetas/etiquetas.gql';
import RegistrarNuevaEtiqueta from '@/components/administracion/configuracion/catalogos/etiquetas/Nueva.vue';
import EditarEtiqueta from '@/components/administracion/configuracion/catalogos/etiquetas/Editar.vue';
import EliminarEtiqueta from '@/components/administracion/configuracion/catalogos/etiquetas/Eliminar.vue';
import eventBus from '@/helpers/eventBus';
import ToolBar from './ToolBar.vue';
import Listado from './listado/Main.vue';
import TituloToolBar from './TituloToolBar.vue';

export default {
  name: 'EtiquetassDefault',
  components: {
    TituloToolBar,
    RegistrarNuevaEtiqueta,
    EditarEtiqueta,
    EliminarEtiqueta,
    ToolBar,
    Listado,
  },
  data() {
    return {
      mostrarVentanaRegistrarNuevaEtiqueta: false,
      mostrarVentanaEditarEtiqueta: false,
      mostrarVentanaEliminarEtiqueta: false,
      estaEtiqueta: null,
      filtros: {
        buscarTexto: '',
        modulo: null,
      },
      etiquetasFiltros: {
        modulo: null,
      },
    };
  },
  mounted() {
    eventBus.$on('editar-etiqueta', (etiqueta) => {
      this.estaEtiqueta = etiqueta;
      this.mostrarVentanaEditarEtiqueta = true;
    });
    eventBus.$on('eliminar-etiqueta', (etiqueta) => {
      this.estaEtiqueta = etiqueta;
      this.mostrarVentanaEliminarEtiqueta = true;
    });
  },
  apollo: {
    etiquetas: {
      query: ETIQUETAS,
      variables() {
        return {
          filtros: {
            modulo: this.etiquetasFiltros.modulo,
          },
        };
      },
    },
  },
  methods: {
    registrarNuevaEtiqueta() {
      this.mostrarVentanaRegistrarNuevaEtiqueta = true;
    },
    cerrarVentana() {
      this.mostrarVentanaRegistrarNuevaEtiqueta = false;
      this.mostrarVentanaEditarEtiqueta = false;
      this.mostrarVentanaEliminarEtiqueta = false;
      this.estaEtiqueta = null;
    },
  },
  computed: {
    getEtiquetas() {
      if (!this.etiquetas) return [];
      return this.etiquetas
      // Filtrar por Texto de Busqueda
        .filter((etiqueta) => {
          if (!this.filtros.buscarTexto) return etiqueta;
          const expt = new RegExp(this.filtros.buscarTexto, 'gi');
          const nombre = this.$normalizacionTexto(etiqueta.nombre);
          return (
            expt.test(nombre)
            || expt.test(etiqueta.nombre)
          );
        });
    },
  },
};
</script>

<style lang="scss">

</style>
